/* Linéor theme scripts. No dependencies. Everything is delegated on document,
   so sections re-rendered by the theme editor keep working. */
(function () {
  'use strict';

  var theme = window.theme || { routes: {}, strings: {} };
  var lastFocus = null;

  function parse(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  /* ---------- Menu drawer, dropdowns, search ---------- */
  function closeDetails(except) {
    document.querySelectorAll('[data-dropdown][open], [data-menu-drawer][open]').forEach(function (el) {
      if (el !== except && !el.contains(except)) el.removeAttribute('open');
    });
  }

  document.addEventListener('toggle', function (e) {
    var el = e.target;
    if (!(el instanceof HTMLDetailsElement)) return;
    if (el.matches('[data-menu-drawer]')) {
      document.body.classList.toggle('no-scroll', el.open);
    }
    if (el.open && el.matches('[data-dropdown], [data-menu-drawer]')) {
      closeDetails(el);
      var input = el.querySelector('input[type="search"]');
      if (input) input.focus();
    }
  }, true);

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-close]')) {
      var drawer = e.target.closest('[data-menu-drawer]');
      if (drawer) drawer.removeAttribute('open');
      document.body.classList.remove('no-scroll');
      return;
    }
    if (!e.target.closest('[data-dropdown]')) {
      document.querySelectorAll('[data-dropdown][open]').forEach(function (el) { el.removeAttribute('open'); });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openDetails = document.querySelector('[data-dropdown][open], [data-menu-drawer][open]');
    if (openDetails) {
      openDetails.removeAttribute('open');
      document.body.classList.remove('no-scroll');
      var summary = openDetails.querySelector('summary');
      if (summary) summary.focus();
    }
    if (cartDrawer() && cartDrawer().classList.contains('is-open')) closeCart();
  });

  /* ---------- Cart drawer ---------- */
  function cartDrawer() {
    return document.getElementById('CartDrawer');
  }

  function openCart() {
    var drawer = cartDrawer();
    if (!drawer) return false;
    lastFocus = document.activeElement;
    drawer.inert = false;
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open');
    document.body.classList.add('no-scroll');
    var panel = drawer.querySelector('.drawer__panel');
    if (panel) panel.focus();
    return true;
  }

  function closeCart() {
    var drawer = cartDrawer();
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.inert = true;
    document.body.classList.remove('no-scroll');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function updateCount(count) {
    if (typeof count !== 'number' || isNaN(count)) return;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function renderCart(html) {
    var drawer = cartDrawer();
    if (!drawer || !html) return;
    var fresh = parse(html).querySelector('.drawer__panel');
    var panel = drawer.querySelector('.drawer__panel');
    if (fresh && panel) {
      panel.innerHTML = fresh.innerHTML;
      panel.dataset.itemCount = fresh.dataset.itemCount;
      updateCount(Number(fresh.dataset.itemCount));
    }
  }

  function useDrawer() {
    return theme.cartType === 'drawer' && cartDrawer() && document.body.dataset.template !== 'cart';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-toggle]') && useDrawer()) {
      e.preventDefault();
      openCart();
      return;
    }
    if (e.target.closest('[data-drawer-close]')) {
      closeCart();
    }
  });

  function changeLine(key, quantity) {
    var drawer = cartDrawer();
    var body = drawer && drawer.querySelector('.drawer__body');
    if (body) body.classList.add('is-loading');
    return fetch(theme.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: ['cart-drawer'], sections_url: window.location.pathname })
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (result) {
        if (!result.ok) throw new Error(result.data.description || result.data.message || theme.strings.cartError);
        renderCart(result.data.sections && result.data.sections['cart-drawer']);
      })
      .catch(function (err) {
        var msg = drawer && drawer.querySelector('[data-cart-error]');
        if (msg) { msg.textContent = err.message || theme.strings.cartError; msg.hidden = false; }
        if (body) body.classList.remove('is-loading');
      });
  }

  var changeTimer = null;
  document.addEventListener('change', function (e) {
    var input = e.target.closest('#CartDrawer [data-line-key]');
    if (!input) return;
    clearTimeout(changeTimer);
    changeTimer = setTimeout(function () {
      changeLine(input.dataset.lineKey, Math.max(0, parseInt(input.value, 10) || 0));
    }, 300);
  });

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('#CartDrawer [data-remove]');
    if (remove) changeLine(remove.dataset.remove, 0);
  });

  /* ---------- Quantity steppers (product page, cart page, drawer) ---------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var input = step.parentElement.querySelector('input');
    if (!input) return;
    var min = input.min !== '' ? Number(input.min) : 0;
    var next = Math.max(min, (parseInt(input.value, 10) || 0) + Number(step.dataset.qtyStep));
    if (String(next) === input.value) return;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form || !useDrawer()) return;
    e.preventDefault();

    var button = form.querySelector('[data-add-button]');
    var error = form.querySelector('[data-form-error]');
    if (error) error.hidden = true;
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }

    var data = new FormData(form);
    data.append('sections', 'cart-drawer');
    data.append('sections_url', window.location.pathname);

    fetch(theme.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    })
      .then(function (res) { return res.json().then(function (json) { return { ok: res.ok, data: json }; }); })
      .then(function (result) {
        if (!result.ok) throw new Error(result.data.description || result.data.message || theme.strings.cartError);
        renderCart(result.data.sections && result.data.sections['cart-drawer']);
        openCart();
      })
      .catch(function (err) {
        if (error) { error.textContent = err.message || theme.strings.cartError; error.hidden = false; }
      })
      .finally(function () {
        if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
      });
  });

  /* ---------- Variant picker ---------- */
  document.addEventListener('change', function (e) {
    var radio = e.target.closest('[data-variant-picker] input[type="radio"]');
    if (!radio) return;
    var section = radio.closest('[data-product-section]');
    if (section) onVariantChange(section);
  });

  function onVariantChange(section) {
    var jsonEl = section.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var variants = JSON.parse(jsonEl.textContent);
    var fieldsets = section.querySelectorAll('[data-variant-picker] fieldset');
    var selected = Array.prototype.map.call(fieldsets, function (fs) {
      var checked = fs.querySelector('input:checked');
      var label = fs.querySelector('[data-option-label]');
      if (checked && label) label.textContent = checked.value;
      return checked ? checked.value : null;
    });

    var variant = variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === selected[i]; });
    });

    var button = section.querySelector('[data-add-button]');
    var label = button && button.querySelector('[data-add-label]');
    if (!variant) {
      if (button) button.disabled = true;
      if (label) label.textContent = theme.strings.unavailable;
      return;
    }

    var idInput = section.querySelector('[data-variant-id]');
    if (idInput) idInput.value = variant.id;
    if (button) button.disabled = !variant.available;
    if (label) label.textContent = variant.available ? theme.strings.addToCart : theme.strings.soldOut;

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());

    if (variant.media) {
      // Product page gallery: move the colour's image to the front.
      var item = section.querySelector('[data-media-id="' + variant.media + '"]');
      if (item && item.parentElement) {
        item.parentElement.prepend(item);
        item.parentElement.scrollLeft = 0;
      }
    }
    // Homepage featured product: swap the single image.
    var featureImg = section.querySelector('[data-feature-img]');
    if (featureImg && variant.img) {
      if (variant.srcset) featureImg.srcset = variant.srcset;
      featureImg.src = variant.img;
    }

    var current = section.querySelector('[data-price-current]');
    var compare = section.querySelector('[data-price-compare]');
    if (current) current.textContent = variant.price;
    if (compare) {
      compare.textContent = variant.compare || '';
      compare.hidden = !variant.compare;
    }
  }

  /* ---------- Collection: sort submits on change ---------- */
  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-auto-submit]');
    if (select && select.form) select.form.submit();
  });

  /* ---------- Product recommendations ---------- */
  function loadRecommendations(root) {
    (root || document).querySelectorAll('[data-recommendations]').forEach(function (el) {
      if (el.dataset.loaded || !el.dataset.url) return;
      el.dataset.loaded = 'true';
      fetch(el.dataset.url)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var fresh = parse(html).querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    });
  }

  document.addEventListener('DOMContentLoaded', function () { loadRecommendations(); });
  if (document.readyState !== 'loading') loadRecommendations();
  document.addEventListener('shopify:section:load', function (e) { loadRecommendations(e.target); });
})();
